import { Grid, GridItem, Skeleton } from '@/design-system/components/ui';

export const TriggerFormSkeleton = () => {
  return (
    <Grid cols={12} gap={4}>
      <GridItem span={12}>
        <Skeleton variant="text" width="60%" height={24} />
      </GridItem>
      <GridItem span={12}>
        <Skeleton variant="rounded" height={56} />
      </GridItem>
      <GridItem span={12}>
        <Skeleton variant="rounded" height={56} />
      </GridItem>
      <GridItem span={6}>
        <Skeleton variant="rounded" height={56} />
      </GridItem>
      <GridItem span={6}>
        <Skeleton variant="rounded" height={56} />
      </GridItem>
      <GridItem span={12}>
        <Skeleton variant="text" width="40%" height={24} />
      </GridItem>
      <GridItem span={12}>
        <Skeleton variant="rounded" height={56} />
      </GridItem>
      <GridItem span={12}>
        <div className="tw:flex tw:flex-row tw:gap-4 tw:justify-end">
          <Skeleton variant="rounded" width={100} height={40} />
          <Skeleton variant="rounded" width={100} height={40} />
        </div>
      </GridItem>
    </Grid>
  );
};
